import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {vnApp_emaki} from "../components/vnApp_emaki";
import {author_management_template} from "../components/templates/author_management_template";

declare var ko: any;
declare var page: any;

export class author_management extends vnModule_knockoutJS{

    protected authorManagement: author_management_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected pagination: pagination_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected timer;
    protected contentTypeColors = {
        Affiliate: "#2BBCAB",
        Authority: "#D2005C",
        Feature: "#1870B9",
        List: "#63008F",
        News: "#6891DC",
        Resource: "#E69E78",
    };

    protected getModuleName(): string{

        return "author_management";
    }

    buildContent(): Array<Element>{

        // create the article list
        this.authorManagement = new author_management_template("list", this.viewModel, this);
        this.template = this.authorManagement;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Author Management");

        let app:vnApp_emaki = <vnApp_emaki>this.getVnAppZone().getApp();

        return [this.authorManagement.build()];
    }

    public fillPage() : void{

        this.authorManagement.buildDatePickerCalendar();
        this.getListFormData();
    }

    public getListFormData(): void{

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdl.execute();

    }

    protected onListFormDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
            });

            obj.loadingOut(obj.authorManagement.builtTemplate.children.namedItem("w-dashboard"));
        }
    }

    protected updateFilters(responseParsed: any){

        this.authorManagement.setGroupContentTypeFilterItems(responseParsed.groupContentTypes);
        this.authorManagement.setNetworkCategoriesFilterItems(responseParsed.networkCategories);
        this.authorManagement.setIntentFilterItems(responseParsed.intents);
        this.authorManagement.setIsActiveFilterItems([{id: 1, name: "Yes"}, {id: 0, name: "No"}]);
        //this.authorManagement.setCanSearchUsers(responseParsed.userFilterEnable);
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.authorManagement.builtTemplate.children.namedItem("w-dashboard"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/authorManagement/get/';

        let subViewModel = this.authorManagement.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'author_management');
    }

    protected exportList(){

        // LOADING : starts
        this.loadingIn(this.authorManagement.builtTemplate.children.namedItem("w-dashboard").children.namedItem("dashboard").children.namedItem("author-list"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/authorManagement/get/';

        let subViewModel = this.authorManagement.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onExportListReturn, XMLHttpRequestHandler_requestType.GET, 'author_management');
    }

    protected onExportListReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.toExportData(responseParsed);
            });

            obj.loadingOut(obj.authorManagement.builtTemplate.children.namedItem("w-dashboard").children.namedItem("dashboard").children.namedItem("author-list"));
        }
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });

            obj.loadingOut(obj.authorManagement.builtTemplate.children.namedItem("w-dashboard"));
        }
    }

    protected toExportData(responseParsed: any){
        const extractedData = responseParsed.data.data.map(obj => ({
            AuthorName: obj.AuthorName,
            newArticlesPublished: this.numberWithCommas(obj.newArticlesPublished),
            failureRate: obj.failureRate != null ? (parseInt(obj.failureRate)).toString() + " %" : obj.failureRate,
            articleRepublish: this.numberWithCommas(obj.articleRepublishCount),
            sessions: this.numberWithCommas(obj.sessions),
            activeSessions: this.numberWithCommas(obj.activeSessions),
            ActiveSA: obj.ActiveSA != null ? this.numberWithCommas(obj.ActiveSA) : '0',
            successRate: obj.successRate != null ? (parseInt(obj.successRate)).toString() + " %" : '0'
        }));


        this.authorManagement.exportData(extractedData);
    }

    protected updateList(responseParsed: any) {

        let publishCountData = this.arrangeDataPublishCount(responseParsed.data.publishCount);
        let activeSessionCountData = this.arrangeActiveSessionCount(responseParsed.data.activeSessionTotalSession);
        let totalSessions = this.arrangeTotalSession(responseParsed.data.activeSessionTotalSession);
        let activeSessionsBaselineSessions = this.arrangeActiveSessionsBaselineSessions(responseParsed.data.activeSessionBaselineSession);
        let publishCountDateData = this.arrangeDataPublishCountStacked(responseParsed.data.publishCountDateData);

        let authorListArrange = this.authorListArrange(responseParsed.data.data);
        this.authorManagement.setAuthors(authorListArrange);
        this.authorManagement.setPublishCountStacked(publishCountDateData);

        this.authorManagement.setPublishCount(publishCountData);
        this.authorManagement.setActiveSessions(activeSessionCountData);
        this.authorManagement.setTotalSessions(totalSessions);
        this.authorManagement.setActiveSessionBaselineSession(activeSessionsBaselineSessions);
        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.authorManagement.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);

        //this.authorManagement.setCanSearchUsers(true);
    }

    public authorListArrange(data){
        return data.map(obj => ({
            AuthorName: obj.AuthorName,
            newArticlesPublished: this.numberWithCommas(obj.newArticlesPublished),
            failureRate: obj.failureRate !== null ? (parseInt(obj.failureRate)).toString() + " %" : obj.failureRate,
            articleRepublish: this.numberWithCommas(obj.articleRepublishCount),
            sessions: this.numberWithCommas(obj.sessions),
            activeSessions: this.numberWithCommas(obj.activeSessions),
            ActiveSA: this.numberWithCommas(obj.ActiveSA),
            successRate: obj.successRate !== null ? (parseInt(obj.successRate)).toString() + " %" : obj.successRate
        }));
    }

    public numberWithCommas(number) {
        // Convert the number to a string
        if(number !== null){

            const numberString = String(number);

            // Split the string into whole and decimal parts (if any)
            const parts = numberString.split(".");

            // Add commas to the whole part
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            // Rejoin the parts and return the formatted number
            return parts.join(".");
        }
    }

    public arrangeDataPublishCountStacked(data){

        const result = [];
        for (const obj of data) {
            //let totalPublished = parseInt(obj.articlesPublished, 10) + parseInt(obj.republishCount, 10);

            result.push({ category: obj.dateData, count: parseInt(obj.articlesPublished, 10), count2: parseInt(obj.republishCount, 10)});
        }

        return result;
    }
    public arrangeActiveSessionsBaselineSessions(data){
        const returnData = [];

        for(const obj of data ){
            //let dateString = obj.dateData + "T00:00:00Z";
            returnData.push({ date: obj.dateData, baseline: parseInt(obj.baseline), activeSA: parseInt(obj.ActiveSA) });
        }
        return returnData;
    }

    public arrangeDataPublishCount(data){

        const result = [];

        let contentTypeGroupsNames = this.authorManagement.getContentTypeGroups().map((cg) => cg.name);
        for (const contentTypeGroupsName of contentTypeGroupsNames) {

            let dataItem = {category: contentTypeGroupsName, count: 0, color: this.getContentTypeForCategory(contentTypeGroupsName)};

            for (const obj of data) {
                if (String(obj.contentGroup).toLowerCase() == String(contentTypeGroupsName).toLowerCase()) {

                    dataItem.count = parseInt(obj.articlesPublished, 10) + parseInt(obj.republishCount, 10);
                    break;
                }
            }

            result.push(dataItem);
        }

        return result.sort((a, b) => {
            if(a.category < b.category) { return -1; }
            if(a.category > b.category) { return 1; }
            return 0;
        });
    }

    public arrangeActiveSessionCount(data){

        const result = [];

        if (data.length == 0) {
            let contentTypeGroups = this.authorManagement.getContentTypeGroups();
            for (const obj of contentTypeGroups) {

                result.push({ category: obj.name, count: 0, color: this.getContentTypeForCategory(obj.name)});
            }

        } else {

            for (const obj of data) {

                result.push({ category: obj.contentGroup, count: obj.activeSessions, color: this.getContentTypeForCategory(obj.contentGroup)});
            }
        }
        return result;
    }

    public arrangeTotalSession(data){

        const result = [];
        if (data.length == 0) {
            let contentTypeGroups = this.authorManagement.getContentTypeGroups();
            for (const obj of contentTypeGroups) {

                result.push({ category: obj.name, count: 0, color: this.getContentTypeForCategory(obj.name) });
            }

        } else {
            for (const obj of data) {

                result.push({category: obj.contentGroup, count: obj.totalSessions, color: this.getContentTypeForCategory(obj.contentGroup)});
            }
        }
        return result;

    }

    protected paginationOnPageClick(){

        this.filterList();
    }


    protected filterDateOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterMultipleSelectorOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected articlesListReorder(){

        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getSuggestions(keyword, idSourceElement) {

        if (idSourceElement == "filterUser") {

            let filterTypes = this.authorManagement.filterUser.getTemplateViewModel();
            this.getUsersSuggestion(filterTypes.inputText(), 5);

        }
    }

    protected getUsersSuggestion(keyword, idElement) {

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        let data = [];
                        for(const obj of responseParsed.data.users){
                            data.push({id:obj.id,name: obj.valnet_user.fullNameAndLogin})
                        }
                        obj.authorManagement.filterUser.setOptions(data);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.authorManagement.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.authorManagement.deactivateLoading();
            }
        }

    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "filterUser" )
        {

            let filterTypes = this.authorManagement.filterUser.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.authorManagement.filterUser.setOptions([]);

            }
        }

    }

    protected getArticlesSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/30DaysPerformance/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        obj.authorManagement.setArticlesFilter(responseParsed.data.articles);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.authorManagement.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.authorManagement.deactivateLoading();
            }
        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterUser") {
            let user = this.authorManagement.filterUser.getTemplateViewModel().optionObj();
            if (user) {
                let currentUsers = this.authorManagement.getTemplateViewModel().usersArray();
                let addUser = true;
                for(let i =0; i<currentUsers.length; i++){
                    if(currentUsers[i].id == user.id){
                        addUser = false;
                        break;
                    }
                }
                if(addUser){
                    currentUsers.push(user);
                    this.authorManagement.getTemplateViewModel().usersArray(currentUsers);
                    this.filterSimpleOnChange();
                }
                this.authorManagement.filterUser.clearSelectedOption();
            }
        }
    }

    protected onAutocompleteInputClear(idElement){

        if (idElement == "filterUser") {
            this.authorManagement.getTemplateViewModel().usersArray([]);
        }
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdl ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.authorManagement.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.authorManagement.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Preset saved successfully.");
                obj.getVnAppZone().showNotificationToModule();
            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);
                obj.getVnAppZone().showNotificationToModule();
            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.authorManagement.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.authorManagement.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected setDefaultStatusFilters(){
        this.authorManagement.setDefaultDateRange();
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.authorManagement.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getContentTypeForCategory(category: string): string {
        let contentTypeColor = this.contentTypeColors[category];
        if (!contentTypeColor) {
            return this.contentTypeColors.Affiliate;
        }
        return contentTypeColor;
    }
}


// WEBPACK FOOTER //
// ./js/modules/author_management.ts